// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import UnreadCount from 'components/UI/Communication/UnreadCount/UnreadCount';
import { useUnreadCount } from 'hooks/useUnreadCount';
import {
  ChannelType,
  OnlineUserType,
} from 'pages/Workspace/ProjectDetails/components/Communication/Communication';
import React from 'react';
import './MessageList.module.scss';
// =========================

export default function MessageList({
  list,
  handleChannelChange,
  notifications,
  activeChannel,
  onlineUsers,
}: {
  list: ChannelType[];
  handleChannelChange: (channel: ChannelType) => void;
  notifications: { [key: string]: number };
  activeChannel: ChannelType;
  onlineUsers: OnlineUserType[];
}) {
  const getUnreadCount = useUnreadCount(notifications);

  return (
    <div styleName="list">
      {list?.map((e, i) => {
        const isOnline = !!(
          e.member && onlineUsers.find((u) => u.id === e.member?.id)
        );

        return (
          <div
            styleName={`item ${activeChannel?.id === e?.id ? 'active' : ''} ${
              isOnline ? 'is-online' : ''
            }`}
            key={i}
            onClick={() => handleChannelChange(e)}
          >
            {e.member ? (
              <Avatar user={e.member} />
            ) : (
              <img src={e?.image} alt={e?.name} />
            )}
            <p>{e?.name}</p>
            {isOnline && <span styleName="online" />}
            {!!getUnreadCount(e) && <UnreadCount count={getUnreadCount(e)} />}
          </div>
        );
      })}
    </div>
  );
}
